import { jsx as n } from "react/jsx-runtime";
import { Link as u } from "./index.es62.js";
import { Button as a } from "./index.es11.js";
const b = "banner-action-button", T = ({
  children: o,
  isPrimary: i,
  LeftIcon: m,
  RightIcon: e,
  testId: t = b,
  variant: s = "secondary-blue",
  onClick: r
}) => i ? /* @__PURE__ */ n(
  a,
  {
    testId: t,
    onClick: r,
    variant: s,
    size: "small",
    LeftIcon: m,
    RightIcon: e,
    children: o
  }
) : /* @__PURE__ */ n(u, { testId: t, onClick: r, weight: "semi-bold", children: o });
export {
  T as ActionButton,
  b as BANNER_ACTION_DEFAULT_TESTID
};
//# sourceMappingURL=index.es756.js.map
